exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".page[data-v-6d4e05ea]{padding-top:60px}.page .body[data-v-6d4e05ea]{padding-bottom:80px}.page .body p[data-v-6d4e05ea]{font-size:14px}.page .body ul[data-v-6d4e05ea]{list-style-type:none;padding:0;margin:0}.page .body ul li[data-v-6d4e05ea]{display:flex;justify-content:space-between;align-items:center;font-size:14px;font-weight:500;border-bottom:1px solid #ccc;padding:10px 0}.page .body ul li p[data-v-6d4e05ea]{margin:0;margin-top:4px;font-weight:600}.page .body ul li small[data-v-6d4e05ea]{color:#777}.page .btn-scan[data-v-6d4e05ea]{position:fixed;bottom:0;left:0;width:100%;background-color:#fff;border-top:1px solid #ccc}.page .btn-scan button[data-v-6d4e05ea]{margin:20px;width:calc(100% - 40px)}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-6d4e05ea","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/pages/ValidasiToga.vue
// module id = 216
// module chunks = 0